module.exports = __webpack_public_path__ + "static/media/AILA.96584cc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/AILA.jpg
// module id = 1707
// module chunks = 1